import React from 'react'
import Styles from './ButtonStyles.module.css';
export default function Button({text,type,onClickFunc,disabled,minWidth}) {
  return (
    <>
    <button disabled={disabled} style={{minWidth:`${minWidth}`}} className={`${type==='primary'?Styles.buttonPrimary:Styles.buttonCancel}`}  onClick={onClickFunc}>{text}</button>
    </>
  )
}
